function ToolboxParticipantRow({ nombre, legajo, isSelected = false, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`grid w-full grid-cols-[1.5fr_0.9fr] items-start gap-3 border-b border-[#d7eee9] px-3 py-3 text-left transition ${
        isSelected
          ? 'bg-[#0a8d6f] shadow-[inset_0_0_0_1px_rgba(255,255,255,0.15)]'
          : 'bg-white hover:bg-[#f7fafc]'
      }`}
    >
      <span
        className={`font-login text-[11px] font-bold uppercase leading-[1.35] sm:text-[12px] ${
          isSelected ? 'text-white' : 'text-[#20525a]'
        }`}
      >
        {nombre}
      </span>
      <span
        className={`font-login text-[11px] font-semibold uppercase leading-[1.35] sm:text-[12px] ${
          isSelected ? 'text-white' : 'text-[#20525a]'
        }`}
      >
        {legajo}
      </span>
    </button>
  );
}

export default ToolboxParticipantRow;
